import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@icon/flag.svg'
import _imports_1 from '@icon/clock.svg'
import _imports_2 from '@icon/calendar-full.svg'
import _imports_3 from '@icon/calendar.svg'


const _hoisted_1 = { class: "to-do__datepicker" }
const _hoisted_2 = { class: "to-do__datepicker-presets" }
const _hoisted_3 = ["aria-pressed"]
const _hoisted_4 = ["aria-pressed"]
const _hoisted_5 = ["aria-pressed"]
const _hoisted_6 = { class: "to-do__datepicker-input" }
const _hoisted_7 = ["onClick"]
const _hoisted_8 = { class: "to-do__calendar-heading" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", { class: "to-do__calendar-label" }, "Due Date", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_BaseSubHeading = _resolveComponent("BaseSubHeading")!
  const _component_icon = _resolveComponent("icon")!
  const _component_v_date_picker = _resolveComponent("v-date-picker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_BaseSubHeading, {
      size: "large",
      weight: "400",
      color: "monochrome-06",
      class: "to-do__datepicker-title"
    }, {
      default: _withCtx(() => [
        _createTextVNode(" Due Date (optional): ")
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["to-do__datepicker-preset is-urgent", { 'is-active': _ctx.urgent }]),
        "aria-pressed": _ctx.urgent,
        onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.updateUrgent(!_ctx.urgent)))
      }, [
        _createVNode(_component_icon, {
          data: _imports_0,
          fill: true,
          width: "var(--icon-16)",
          height: "var(--icon-16)"
        }),
        _createTextVNode(" Urgent ")
      ], 10, _hoisted_3),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["to-do__datepicker-preset is-today", { 'is-active': _ctx.today }]),
        "aria-pressed": _ctx.today,
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onCheckboxToday(!_ctx.today)))
      }, [
        _createVNode(_component_icon, {
          data: _imports_1,
          fill: true,
          width: "var(--icon-16)",
          height: "var(--icon-16)"
        }),
        _createTextVNode(" Today ")
      ], 10, _hoisted_4),
      _createElementVNode("button", {
        type: "button",
        class: _normalizeClass(["to-do__datepicker-preset is-tomorrow", { 'is-active': _ctx.tomorrow }]),
        "aria-pressed": _ctx.tomorrow,
        onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.onCheckboxTomorrow(!_ctx.tomorrow)))
      }, [
        _createVNode(_component_icon, {
          data: _imports_2,
          width: "var(--icon-16)",
          height: "var(--icon-16)"
        }),
        _createTextVNode(" Tomorrow ")
      ], 10, _hoisted_5)
    ]),
    _createElementVNode("div", _hoisted_6, [
      _createVNode(_component_v_date_picker, {
        modelValue: _ctx.calendarDate,
        mode: "date",
        color: _ctx.isDark ? 'project' : 'blue',
        locale: "en",
        firstDayOfWeek: 2,
        minDate: _ctx.minDate,
        popover: _ctx.popoverConfig,
        class: "input_to-do",
        "onUpdate:modelValue": _ctx.updateDate,
        onMousedown: _cache[4] || (_cache[4] = ($event: any) => ($event.stopPropagation()))
      }, {
        default: _withCtx(({ togglePopover }) => [
          _createElementVNode("button", {
            id: "selectToDoDate",
            type: "button",
            class: "common-gray-interactive to-do__datepicker-button",
            onClick: togglePopover
          }, [
            _createTextVNode(_toDisplayString(_ctx.parseDate || "MM/DD/YYYY") + " ", 1),
            _createVNode(_component_icon, {
              data: _imports_3,
              width: "var(--icon-24)",
              height: "var(--icon-24)",
              class: "to-do__datepicker-icon"
            })
          ], 8, _hoisted_7)
        ]),
        footer: _withCtx(() => [
          _createElementVNode("div", _hoisted_8, [
            _hoisted_9,
            _createElementVNode("button", {
              type: "button",
              class: "link to-do__calendar-clear",
              onClick: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.updateDate(null)), ["stop"]))
            }, " Clear Date ")
          ])
        ]),
        _: 1
      }, 8, ["modelValue", "color", "minDate", "popover", "onUpdate:modelValue"])
    ])
  ]))
}